export default {
    userid:'',
    userinfo:{
        userid:'',
        username:'',
        userpassword:'',
        userposition:'',
    },
    usermessage:[
        
    ],
    useruncheckmessage:[

    ],
    useruncheckmessagenumber:'',
    LightViewToken:'100031026095'
}